import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompareHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChartCompareHorizontal"><Path d="M4.5 19.5H21V21H3V3H4.5V19.5Z" fill="currentColor"/><Path d="M11 18H6V16.5H11V18Z" fill="currentColor"/><Path d="M19 15H6V13.5H19V15Z" fill="currentColor"/><Path d="M13 10H6V8.5H13V10Z" fill="currentColor"/><Path d="M16 7H6V5.5H16V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartCompareHorizontal;
